import { FC, useCallback, useEffect, useMemo, useState } from "react";
import StatisticsLayout from "../../../../../../components/statisticsLayout";
import { I18n } from "react-redux-i18n";
import { ChartViewTypeEnum, mapValuesFromStringToNumber } from "../helpers";
import { LabelValue } from "../../../../../../types/labelValue";
import { ColumnChart } from "../../../../../../components/charts";
import { useParams } from "react-router-dom";
import { requestApi } from "../../../../../../utils/requestApi";
import { POST } from "../../../../../../types/httpMethod";
import { FilterStatus } from "../../../../../../types/filterStatusValue";

type AverageTimeProps = {
  filterStatus: FilterStatus;
};

const AverageTime: FC<AverageTimeProps> = ({ filterStatus }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
      <Chart type={ChartViewTypeEnum.DEVICE} title={"avgTime"} subTitle={"byDeviceType"} filterStatus={filterStatus} />
      <Chart type={ChartViewTypeEnum.LANGUAGE} subTitle={"byLanguage"} filterStatus={filterStatus} />
      <Chart type={ChartViewTypeEnum.MAILING} subTitle={"byDistributionType"} filterStatus={filterStatus} />
    </div>
  );
};

export default AverageTime;

type ChartProps = { type: ChartViewTypeEnum; title?: string; subTitle: string; filterStatus: FilterStatus };

const Chart: FC<ChartProps> = ({ type, title, subTitle, filterStatus }) => {
  const { data, loading } = useLoadDataByCategory(type, filterStatus);
  return (
    <StatisticsLayout
      padding={"40px"}
      subTitle={I18n.t(subTitle)}
      title={title ? I18n.t(title) : undefined}
      children={<ColumnChart data={data} height={350} loading={loading} />}
    />
  );
};

const useLoadDataByCategory = (type: ChartViewTypeEnum, state: FilterStatus) => {
  const { id: surveyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Array<LabelValue>>([]);

  const loadData = useCallback(() => {
    setLoading(true);
    requestApi(POST, "/chart/average-time", { state: state }, false, false, {}, { surveyId, type })
      .then((res) => setData(mapValuesFromStringToNumber(res)))
      .finally(() => setLoading(false));
  }, [type, surveyId, state]);

  useEffect(() => loadData(), [loadData]);

  return useMemo(() => {
    return { data, loading, reRetch: loadData };
  }, [data, loading]);
};
